import { HiCheckCircle } from 'react-icons/hi';

type ConclusionScrCard = {
  objtConclusionCard: {
    message: string;
    subMessage: string;
    handleFirstButtonAction: () => void;
    firstButtonLabel: string;
    handleLastButtonAction: () => void;
    lastButtonLabel: string;
  };
};

export const ConclusionCard = ({ objtConclusionCard }: ConclusionScrCard) => {
  const parts = objtConclusionCard.subMessage.split('*');

  return (
    <div className="tw-bg-white tw-w-full md:tw-max-w-[80%] tw-flex tw-items-center tw-justify-center tw-flex-col tw-py-[2.5rem] md;tw-py-[5.37rem] tw-rounded-3xl">
      <HiCheckCircle color="#006217" size="4.63rem" />
      <p className="tw-max-w-[18rem] md:tw-max-w-[30rem] tw-font-bold tw-text-[1.5rem] tw-text-[#006217] tw-text-center tw-mt-[1.88rem]">
        {objtConclusionCard.message}
      </p>
      <p className="tw-text-center tw-max-w-[18rem] md:tw-max-w-[30rem] tw-mt-[0.63rem]">
        {parts.map((part, index) => {
          if (index % 2 === 1) {
            return <strong key={index}>{part}</strong>;
          } else {
            return <span key={index}>{part}</span>;
          }
        })}
      </p>
      <div className="tw-flex tw-flex-col tw-gap-[1.25rem] md:tw-gap-[1.87rem] tw-mt-[1.87rem] md:tw-mt-[2.5rem]">
        <button
          onClick={objtConclusionCard.handleFirstButtonAction}
          className="tw-bg-[#FF5000] tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[18rem] tw-py-[0.8rem] tw-rounded-3xl"
        >
          {objtConclusionCard.firstButtonLabel}
        </button>
        <button
          onClick={objtConclusionCard.handleLastButtonAction}
          className="tw-bg-[#001E64] tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[18rem] tw-py-[0.8rem]  tw-rounded-3xl"
        >
          {objtConclusionCard.lastButtonLabel}
        </button>
      </div>
    </div>
  );
};
